<template>
  <div
    @touchstart="onTouchstart"
    :class="['ai_box', (this.$root.$data.miniprogram || this.$root.$data.isApp) ? 'ai_box_top' : '']"
  >
    <common-title titleName="伴学助手" :isAPPShow="false" :bcColor="'#f7f8fc'"></common-title>

    <div>
      <div class="list_box">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :offset="20"
          @load="onLoad"
          direction="up"
        >
          <!-- 历史记录 -->
          <div class="history_list_box">
            <div class="history_succ" v-if="finished">没有更多记录了</div>
            <div class="msg_item_box" v-for="item in historyList" :key="item.id">
              <div v-if="toolRawTime(item.createTime) && item.roleType === 1" class="msg_time_box">
                <div class="msg_time">
                  <div>{{ toolRawTime(item.createTime) }}</div>
                </div>
              </div>
              <div
                v-if="item.roleType === 1 && item.messageType !== 'supervision_card' "
                class="user_msg_box"
                :style="[botInfo.msgBgColor ? { background: botInfo.msgBgColor} : {}, botInfo.msgFontColor ? { color: botInfo.msgFontColor} : {}]"
              >{{item.content}}</div>

              <div
                v-if="item.roleType === 2  && item.messageType !== 'supervision_card' "
                class="ai_msg_box"
              >
                <div class="ai_title" v-if="botInfo.showAvatar == 1">
                  <img
                    class="ai_title_img"
                    :src="botInfo.appAvatar || 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/title_icon.png'"
                    alt
                  />
                  <div class="ai_title_text">{{ botInfo.appNickname || '启小航' }}</div>
                </div>

                <div class="ai_msg_list">
                  <div class="ai_msg_item" v-for="itm in item.contentList" :key="itm.key">
                    <!-- markdown渲染 -->
                    <div
                      v-if="itm.formatType === 1 || item.formatType === 9"
                      class="ai_msg_markdown"
                      v-html="toolMdRender(itm.content)"
                    ></div>
                    <!-- 公式渲染 -->
                    <Katex
                      v-else
                      class="ai_msg_katex"
                      :fomula="toolResetRichText(itm.content)"
                      :id="itm.key"
                    />
                  </div>
                  <div v-if="item.isStop" class="stop_tip">已停止回答</div>
                </div>
              </div>

              <!-- 打招呼语 -->
              <div
                class="wecome_box"
                v-if="item.roleType === 1314 && item.messageType !== 'supervision_card' "
              >
                <div
                  class="wecome_icon_box"
                  :style="[botInfo.welcomeBgImage ? { background: `url(${botInfo.welcomeBgImage}) no-repeat`} : {}]"
                >
                  <div class="wecome_title_hello">{{wecomeTitleObj.wecomeTitle}}</div>
                  <div class="wecome_title_text">{{wecomeTitleObj.wecomeText}}</div>
                </div>
                <div class="wecome_list">
                  <div class="wecome_list_title">
                    <div class="wecome_list_tip">你可以试着问我：</div>
                    <img
                      class="refresh_icon"
                      src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/wecome_refresh_icon.png"
                      alt
                      @click="onSwapHello"
                    />
                    <div class="refresh_tip" @click="onSwapHello">换一批</div>
                  </div>
                  <div class="wecome_quick_list">
                    <div
                      class="wecome_quick_item"
                      v-for="item in currentWecomeList"
                      :key="item"
                      @click="onQuickSend(item)"
                    >
                      <div class="wecome_quick_text">{{item}}</div>
                      <img
                        class="wecome_quick_icon"
                        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/wecome_quick_icon.png"
                        alt
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- 督学卡片 -->
              <div class="supervisor_box" v-if="item.messageType == 'supervision_card'">
                <img
                  class="supervisor_icon"
                  src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/supervisor_icon.png"
                  alt
                />
                <div class="supervisor_text1">今日有未完成的学习任务！</div>
                <div class="supervisor_text2">今日学，不拖延</div>
                <div
                  :class="['supervisor_btn', item.activeKey === lastSupervisor ? 'supervisor_btn_actvie' : '']"
                  @click="onSupervisorJump(item)"
                >{{ item.spervisorStatus === 'completed' ? '已完成' : ( item.activeKey === lastSupervisor ? '去学习' : '已过期') }}</div>
              </div>
            </div>
          </div>

          <!-- 当前对话 -->
          <div class="curr_list_box" v-if="currPreStr || currRenderQueue.length !== 0">
            <div class="msg_item_box">
              <div class="ai_msg_box">
                <div class="ai_title" v-if="botInfo.showAvatar == 1">
                  <img
                    class="ai_title_img"
                    :src="botInfo.appAvatar || 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/title_icon.png'"
                    alt
                  />
                  <div class="ai_title_text">{{ botInfo.appNickname || '启小航' }}</div>
                </div>

                <div class="ai_msg_list">
                  <div class="ai_msg_item" v-for="item in currRenderQueue" :key="item.key">
                    <!-- markdown渲染 -->
                    <div
                      v-if="item.formatType === 1 || item.formatType === 9"
                      class="ai_msg_markdown"
                      v-html="toolMdRender(item.content)"
                    ></div>
                    <!-- 公式渲染 -->
                    <Katex
                      v-else
                      class="ai_msg_katex"
                      :fomula="toolResetRichText(item.content)"
                      :id="item.key"
                    />
                  </div>
                  <!-- 未处理的字符串渲染 -->
                  <div class="ai_msg_text">{{ currPreStr }}</div>
                  <img
                    class="ai_loading"
                    src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/msg_loading.gif"
                    alt
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="msg_ai_tip" v-if="historyList.length !== 0">内容由AI生成</div>
        </van-list>
      </div>

      <img
        v-show="historyList.length !== 0"
        :class="['scroll_icon', scrollIconDisplay ? 'scroll_icon_show' : '']"
        @click="toolScrollUnder"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/scroll_icon.png"
        alt
      />

      <div
        :class="['bottom_box',  inputRender !== -1 ? 'bottom_absolate' : '']"
        @touchstart.stop="onTouchstartStop"
      >
        <div class="jump_btn_box">
          <div class="jump_btn_item">
            <img
              class="jump_btn_icon"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/jump_icon1.png"
              alt
            />
            <div class="jump_btn_text" @click="onReportSend">学习报告</div>
          </div>

          <div class="jump_btn_item">
            <img
              class="jump_btn_icon"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/jump_icon2.png"
              alt
            />
            <div class="jump_btn_text" @click="onGoAnswer">拍照答疑</div>
          </div>
        </div>
        <div class="input_box">
          <div class="input_area">
            <van-form>
              <van-field
                id="aiassistantinput"
                key="jsdfkgsiukejfhiurweh"
                v-model.trim="inputMsg"
                clearable
                placeholder="在这里向我提问哦~"
                @blur="onBulr"
                type="text"
                :disabled="sseActive || execActive"
                @click.stop="onClick"
              />
            </van-form>
          </div>

          <div class="input_btn">
            <!-- 发送按钮 -->
            <img
              v-if="inputMsg && !sseActive && !execActive"
              :src="botInfo.sendBtnImage || 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/input_send.png' "
              alt
              @click="onMySend"
            />

            <!-- 停止按钮 -->
            <img
              v-if="sseActive || execActive"
              :src="botInfo.stopBtnImage || 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/input_stop.png' "
              alt
              @click="onStopImmediately"
            />

            <!-- 禁用按钮 -->
            <img
              v-if="!inputMsg && !sseActive && !execActive "
              :src="'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/input_disable.png' "
              alt
            />
          </div>
        </div>
      </div>
    </div>

    <div class="guide_page" v-if="guideDisplay">
      <img
        class="guide_gif"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/yindaoye.gif"
        alt
      />
      <div class="guide_text1">嗨，我是小航</div>
      <div class="guide_text2">{{guideRenderText}}</div>

      <img
        class="guide_bkg"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/yindaoye_bkg.png"
        alt
      />

      <div class="guide_btn" @click="onGuideDisplay">开启伴学之旅</div>
    </div>

    <div class="task_modal" v-if="taskModal">
      <div class="task_bok">
        <div class="task_btn" @click="taskModal = false">知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
// https://iqh-zt-pord-cdn.iqihang.com
import {
  openAiConnect,
  stopAiConnect,
  getAiBotList,
  getAiInfo,
  getAiSessionId,
  getHistoryAiInfo,
  getAiBotAppoint,
  preReport,
} from '@/api/aiAssistant/index';

import { fetchEventSource } from '@microsoft/fetch-event-source';

import markdownIt from 'markdown-it';

import { resetRichText1 } from '@/utils/tools';
import Katex from '@/components/KaTex/index.vue';
import moment from 'moment';
import { reqTypeList } from '@/api/home';
import wx from 'weixin-js-sdk';
import { miniSchemeUrl } from '@/utils/common';

const md = new markdownIt({ breaks: true, html: true });

export default {
  components: {
    Katex,
  },
  data() {
    return {
      currAiBotCode: 'bxzs001', // 应用code
      currAiBotID: '', // 应用id
      currSessionId: '', // 会话id
      currConnectId: '', // 连接id
      userProductId: this.$route.query.userProductId, // 开课id

      botInfo: {}, // 应用信息

      historyList: [], // 历史记录

      inputMsg: '', // 输入框内容

      wecomeTitleObj: {}, // 招呼语的标题
      showWecome: false, // 是否展示招呼语
      allWecomeList: [], // 全部快捷提问
      currentWecomeList: [], // 当前显示的快捷提问

      currRenderQueue: [], // 处理过的str[]
      currPreStr: '', // 预渲染、未处理
      currCacheQueue: [], // 暂存str[]

      sseActive: false, // sse是否还在进行中
      stopCall: null, // 停止sse方法
      execActive: false, // 流式输出是否在执行中
      stopImmediately: false, // 是否立即停止sse
      sseOpen: false, // sse是否成功open

      dispatchTag: -1, // 公式处理标记

      // 历史记录相关
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,

      // 督学相关
      needSupervisor: false,
      lastSupervisor: '',

      // 处理输入框键盘问题
      noScroll: true,
      inputRender: -1,

      scrollIconSize: -1,
      scrollIconDisplay: true,

      sseType: '',

      guideDisplay: false,

      guideSourceText:
        '你的AI伴学助手，关于考研课程学情分析、学科知识答疑及心理咨询等问题都可以问我！',
      guideRenderText: '',

      taskModal: false,
    };
  },
  mounted() {
    const guideDisplay = window.localStorage.getItem('AI_COMPANION_CHAT_GUIDE');

    this.guideDisplay = !guideDisplay;

    if (this.guideDisplay) {
      let i = 0;
      let timer = setInterval(() => {
        if (this.guideSourceText[i]) {
          this.guideRenderText += this.guideSourceText[i];
          i++;
        } else {
          clearInterval(timer);
          timer = null;
        }
      }, 100);
    }

    console.log(
      'combinationCourse mounted',
      moment('2025-11-09').isBetween(moment('2025-11-09'), moment('2025-11-10'), 'days', []),
    );
    window.addEventListener('scroll', this.scrollChange);

    let currentEnv = '';
    ['pre.iqihang', 'release.iqihang', 'test.iqihang', 'dev.iqihang', 'localhost'].forEach(item => {
      if (window.location.href.indexOf(item) !== -1) {
        currentEnv = item.split('.')?.shift();
      }
    });

    const sseUrlMap = {
      localhost: 'https://sse-test.iqihang.com/v1/ai-sse/connect',
      dev: 'https://sse-dev.iqihang.com/v1/ai-sse/connect',
      test: 'https://sse-test.iqihang.com/v1/ai-sse/connect',
      pre: 'https://sse-pre.iqihang.com/v1/ai-sse/connect',
    };
    const sseUrl = sseUrlMap[currentEnv] || 'https://sse-prod.iqihang.com/v1/ai-sse/connect';

    this.sseUrl = `${sseUrl}?businessType=3`;

    // 预先生成一下学习报告
    preReport(this.userProductId);

    this.getAiBot();

    setTimeout(() => {
      //   this.eventReq('给我一个markdown格式一段纯文字,有加粗、换行、标题。但不要有数学公式');
      //   this.eventReq('给我一个表格的知识点，简短一些即可');
      // this.eventReq('给我一个简单的洛必达公式');
    }, 3000);
  },
  methods: {
    onGuideDisplay() {
      this.guideDisplay = false;
      window.localStorage.setItem('AI_COMPANION_CHAT_GUIDE', 'true');
    },
    // 获取应用信息
    getAiBot() {
      getAiBotAppoint(this.currAiBotCode).then(res => {
        const { data, currentTime } = res;
        this.currentTime = currentTime;

        const { id, recommendPrompts, cardTemplate } = data || {};

        if (cardTemplate == 1) {
          this.wecomeTitleObj = {
            wecomeTitle: data.guideTitle,
            wecomeText: data.guideText,
          };
        } else {
          this.toolGetTimeRange(currentTime?.slice(11), data);
        }

        this.botInfo = data;

        document.title = data.name;

        // 处理三条随机的欢迎语
        const recommendPromptsList = recommendPrompts ? JSON.parse(recommendPrompts) : [];
        this.allWecomeList = recommendPromptsList;
        this.currentWecomeList = this.toolRandomWeCome(recommendPromptsList);

        this.currAiBotID = id;

        this.getSession(id);
      });
    },

    // 获取会话信息
    getSession(id) {
      getAiSessionId(id, this.userProductId).then(res2 => {
        this.currSessionId = res2?.data;
        this.getHistoryList(true);
      });
    },

    // 获取历史记录
    getHistoryList(init = false) {
      getHistoryAiInfo(this.currSessionId, this.pageNum, this.pageSize).then(res => {
        const list = this.formatHistoryList(res.data?.data?.reverse() || []);
        if (list.length > 0) {
          this.pageNum += 1;
          this.historyList = [...list, ...this.historyList];
          this.toolTableColor();
          // const randomKey = Math.random()
          //   .toFixed(10)
          //   .slice(2);
          // this.historyList.push({
          //   messageType: 2,
          //   activeKey: randomKey,
          //   spervisorStatus: '',
          // });
          // this.lastSupervisor = randomKey;
          const afterItem = res.data?.data?.findLast(item => item.roleType === 1);

          if (!afterItem && init) {
            this.showWecome = true;
            this.historyList.push({
              roleType: 1314,
            });
            this.toolScrollUnder();
            this.loading = false;
            return;
          }
          if (init && moment(res.currentTime).diff(moment(afterItem.createTime), 'minutes') > 60) {
            this.showWecome = true;
            this.historyList.push({
              roleType: 1314,
            });
          }

          if (init) {
            this.toolScrollUnder();
          } else {
            this.$nextTick(() => {
              const currTop =
                document.getElementsByClassName('msg_item_box')[list.length]?.offsetTop ||
                999999999999;
              window.scroll(0, currTop);
              this.loading = false;
            });
          }
        } else {
          this.loading = false;
          this.finished = true;
          if (init) {
            this.showWecome = true;
            this.historyList.push({
              roleType: 1314,
            });
          }
        }
      });
    },

    // 格式化历史记录
    formatHistoryList(list) {
      if (list.length === 0) {
        return [];
      }

      const result = list.map(item => {
        const { content, roleType, ...rest } = item;

        // 用户信息
        if (item.roleType === 1) {
          return item;
        }

        // 智能体
        if (item.roleType === 2) {
          // 普通智能体消息

          // 督学卡片处理
          if (item.messageType === 'supervision_card') {
            const { extraData } = item;
            if (extraData) {
              const { status } = JSON.parse(extraData);

              const info = {
                ...item,
                spervisorStatus: status,
              };
              if (item.createTime.slice(0, 10) === this.currentTime.slice(0, 10)) {
                const randomKey = Math.random()
                  .toFixed(10)
                  .slice(2);
                this.lastSupervisor = randomKey;
                info.activeKey = randomKey;
              }
              return info;
            }
            return item;
          } else {
            const preFormatStart = ['$$', '$', '\\(', '\\['];
            const preFormatEnd = ['$$', '$', '\\)', '\\]'];

            // let rawStr = String.raw`${content}`;
            let rawStr = content;

            let contentList = [];

            const tableStart = rawStr.indexOf('|');
            const tableEnd = rawStr.lastIndexOf('|');

            const tableSplit = rawStr.indexOf('---------');

            if (
              tableStart !== -1 &&
              tableEnd !== -1 &&
              tableStart < tableEnd &&
              tableSplit !== -1
            ) {
              contentList.push({
                formatType: 1,
                content: rawStr.slice(0, tableEnd + 1),
              });

              rawStr = rawStr.slice(tableEnd + 1);
            }

            // 指针
            let p = -1;
            let q = -1;

            let tagIndex = -1;

            while (true) {
              if (!rawStr) {
                break;
              }

              // 找公式开始位置
              for (let i = 0; i < preFormatStart.length; i++) {
                const index = rawStr.indexOf(preFormatStart[i]);

                // 取最靠前的一个标签的位置
                if (index > -1 && (p === -1 || index < p)) {
                  p = index;
                  tagIndex = i;
                }
              }

              if (p === -1) {
                // 没找到开始标记
                // contentList.push({
                //   formatType: 1,
                //   content: rawStr,
                // });
                contentList.push(
                  ...rawStr.split('\n').map(item => {
                    return {
                      formatType: 1,
                      content: item,
                    };
                  }),
                );
                break;
              } else {
                if (p > 0) {
                  // p前还有普通文本
                  // contentList.push({
                  //   formatType: 1,
                  //   content: rawStr.slice(0, p),
                  // });
                  contentList.push(
                    ...rawStr
                      .slice(0, p)
                      .split('\n')
                      .map(item => {
                        return {
                          formatType: 1,
                          content: item,
                        };
                      }),
                  );
                }
                // 有开始的标记，找结尾
                const endTag = preFormatEnd[tagIndex];
                q = rawStr.indexOf(endTag, p + 1);
                // 容错处理标签不闭合的情况
                if (q === -1) {
                  contentList.push({
                    formatType: 1,
                    content: rawStr.slice(p),
                  });
                  break;
                }
                contentList.push({
                  formatType: 2,
                  content: rawStr.slice(p, q + endTag.length),
                });

                rawStr = rawStr.slice(q + endTag.length);
                p = -1;
                q = -1;
                tagIndex = -1;
              }
            }

            return {
              ...rest,
              roleType,
              contentList,
            };
          }
        }
      });

      console.log(result, '??????');
      return result;
    },

    // van-list触发
    onLoad() {
      this.loading = true;
      if (!this.finished) {
        this.getHistoryList();
      }
    },

    // 发起提问
    onMySend() {
      if (!this.inputMsg) {
        return;
      }
      this.historyList.push({
        content: this.inputMsg,
        roleType: 1,
      });
      // this.sseActive = true;
      this.eventReq(this.inputMsg);
      this.currPreStr = '对方正在输入中';
      this.inputMsg = '';
      this.toolScrollUnder();
    },

    // 发起快捷提问
    onQuickSend(str) {
      if (!str) {
        return;
      }
      if (this.sseActive || this.execActive) {
        return;
      }
      this.historyList.push({
        content: str,
        roleType: 1,
      });
      // this.sseActive = true;
      this.eventReq(str);
      this.currPreStr = '对方正在输入中';
      this.inputMsg = '';
      this.toolScrollUnder();
    },

    // 获取学习报告
    onReportSend() {
      if (this.sseActive || this.execActive) {
        return;
      }

      this.historyList.push({
        content: '查看学习报告',
        roleType: 1,
      });
      // this.sseActive = true;
      this.eventReq('查看学习报告', 'GET_STUDY_REPORT');
      this.currPreStr = '对方正在输入中';
      this.inputMsg = '';
      this.toolScrollUnder();
    },

    // 终止会话
    onStopImmediately() {
      if (!this.sseOpen) {
        return;
      }
      this.stopCall.abort();
      this.sseActive = false;
      this.currCacheQueue = [];
      this.stopImmediately = true;
      if (!this.execActive) {
        this.disPtachHandle();
      } else {
        this.sseActive = false;
        this.execActive = false;
      }
    },

    // sse请求
    eventReq(str, actionType = 'ASK_QUESTION') {
      const that = this;
      const token = window.localStorage.getItem('accessToken');
      const stop = new AbortController();
      this.stopCall = stop;
      this.sseType = actionType;
      that.sseActive = true;
      let isFirstContent = true;
      let needClearCurrPreStr = false;

      fetchEventSource(this.sseUrl, {
        method: 'POST',
        body: JSON.stringify({
          userProductId: this.userProductId,
          appId: this.currAiBotID,
          sessionId: this.currSessionId,
          content: str,
          actionType: actionType,
        }),
        signal: stop.signal,
        openWhenHidden: true,
        headers: {
          Authorization: `Bearer ${token}`,
          'content-type': 'application/json',
          // accept: '*/*',
        },
        onopen() {
          // 清除预制字符串
          that.sseActive = true;
          that.sseOpen = true;
          return Promise.resolve();
        },
        onmessage(msg) {
          const { data } = msg;
          const { connectId, content, type } = JSON.parse(data);
          that.currConnectId = connectId;

          if (needClearCurrPreStr) {
            needClearCurrPreStr = false;
            that.currPreStr = '';
          }

          if (type == 2002) {
            needClearCurrPreStr = true;
          } else if (isFirstContent) {
            that.currPreStr = '';
          }

          isFirstContent = false;

          if (type == 2000 || type == 2002) {
            if (type == 2002) {
              that.needSupervisor = true;
            }

            if (content) {
              const rowContentList = content
                .split('\n')
                .join('~~\n~~')
                .split('~~')
                .filter(item => !!item);

              that.currCacheQueue.push(...rowContentList);
              if (!that.execActive) {
                that.scheduler();
              }
            }
          }
          if (type == 2001) {
            that.sseActive = false;
          }
        },
        onclose() {
          console.log('链接关闭+++++++++');
          // that.textCallAi = false;
          // that.$nextTick(() => {
          //     if (!that.textCallStr && !that.textCallStrCache) {
          //         that.$nextTick(() => {
          //             that.toolRowTextDy.call(that);
          //         });
          //     }
          // });
        },
        onerror(e) {
          console.log('链接失败+++++++', e);
          //   this.$toast('操作过于频繁，请稍后再试');
          return Promise.resolve();
        },
      });
    },

    // 接受数据流处理
    scheduler() {
      if (this.currCacheQueue.length > 0) {
        // 上锁
        this.execActive = true;

        const nodeStr = this.currCacheQueue.shift();
        if (nodeStr == '\n' && this.sseType !== 'GET_STUDY_REPORT') {
          if (this.currPreStr) {
            const queueLength = this.currRenderQueue.length;
            const lastNode = this.currRenderQueue[queueLength - 1];
            if (lastNode && lastNode?.formatType === 1) {
              this.currRenderQueue.splice(queueLength - 1, 1, {
                ...lastNode,
                content: lastNode.content + this.currPreStr,
              });
            } else {
              this.currRenderQueue.push({
                formatType: 1,
                key: Math.random()
                  .toFixed(6)
                  .slice(2),
                content: this.currPreStr,
              });
            }
            this.currPreStr = '';
          }

          this.currRenderQueue.push({
            formatType: 9, // 单独渲染换行
            key: Math.random()
              .toFixed(6)
              .slice(2),
            content: nodeStr,
          });
          this.scheduler();
        } else {
          this.execute(nodeStr);
        }
      } else {
        this.execActive = false;
      }
    },

    // 打字函数
    execute(str) {
      let index = 0;

      let timer = setInterval(() => {
        if (index < str.length) {
          if (this.stopImmediately) {
            // 还原标识
            this.stopImmediately = false;
            clearInterval(timer);
            timer = null;
            this.disPtachHandle();
          } else {
            this.currPreStr += str[index];
            index++;
          }
        } else {
          clearInterval(timer);
          timer = null;
          this.disPtachHandle();
        }
      }, 10);
    },

    // 对预渲染字符串做一遍处理，找出富文本或者公式
    disPtachHandle() {
      // 复杂处理开始了，要把公式摘出来，但公式可能是多种格式包裹。先支持已知六种
      // 由于已知几种公式包裹，开始符号都小于等于3位字符。所以每次未识别到时，只slice(0, -3)位，可避免标签跨段问题
      // 严格要求智能体格式正确，否则无法正常渲染

      const yuliulength = 6;

      const preFormatStart = ['$$', '$', '\\(', '\\['];
      const preFormatEnd = ['$$', '$', '\\)', '\\]'];

      // 不够预留长度，则不处理
      if (this.currPreStr.length <= yuliulength) {
        if (this.currCacheQueue.length > 0 || this.sseActive) {
          // 再次循环
          this.scheduler();
        } else {
          // 开始截取字符串
          const queueLength = this.currRenderQueue.length;
          const lastNode = this.currRenderQueue[queueLength - 1];

          if (lastNode && lastNode?.formatType === 1) {
            this.currRenderQueue.splice(queueLength - 1, 1, {
              ...lastNode,
              content: lastNode.content + this.currPreStr,
            });
          } else {
            this.currRenderQueue.push({
              formatType: 1,
              key: Math.random()
                .toFixed(6)
                .slice(2),
              content: this.currPreStr,
            });
          }

          // 结果了
          this.execActive = false;
          this.currPreStr = '';
          this.stackPush();
        }
        return;
      }

      // 未找到开始标记呢还
      if (this.dispatchTag === -1) {
        let minIndex = -1;
        let minTag = -1;

        for (let i = 0; i < preFormatStart.length; i++) {
          const index = this.currPreStr.indexOf(preFormatStart[i]);

          // 取最靠前的一个标签的位置
          if (index > -1 && (minIndex === -1 || index < minIndex)) {
            minIndex = index;
            minTag = i;
          }
        }

        let sliceLength = this.currPreStr.length - yuliulength;

        // 找到了开始标记，则截取到标记起始的位置之前
        if (minIndex > -1) {
          this.dispatchTag = minTag;
          sliceLength = minIndex;
        }

        // 开始截取字符串
        const queueLength = this.currRenderQueue.length;
        const lastNode = this.currRenderQueue[queueLength - 1];

        if (lastNode && lastNode?.formatType === 1) {
          this.currRenderQueue.splice(queueLength - 1, 1, {
            ...lastNode,
            content: lastNode.content + this.currPreStr.slice(0, sliceLength),
          });
        } else {
          this.currRenderQueue.push({
            formatType: 1,
            key: Math.random()
              .toFixed(6)
              .slice(2),
            content: this.currPreStr.slice(0, sliceLength),
          });
        }
        this.currPreStr = this.currPreStr.slice(sliceLength);
      } else {
        // 已经存在开始标记，则尝试寻找对应的结尾标记。
        const endTag = preFormatEnd[this.dispatchTag];
        const endTagIndex = this.currPreStr.indexOf(endTag, endTag.length);

        if (endTagIndex > -1) {
          const queueLength = this.currRenderQueue.length;
          const lastNode = this.currRenderQueue[queueLength - 1];

          let sliceLength = endTagIndex + endTag.length;
          if (
            this.currPreStr[sliceLength] == ',' ||
            this.currPreStr[sliceLength] == '.' ||
            this.currPreStr[sliceLength] == '，' ||
            this.currPreStr[sliceLength] == '。'
          ) {
            sliceLength += 1;
          }

          if (lastNode && lastNode?.formatType === 2) {
            this.currRenderQueue.splice(queueLength - 1, 1, {
              ...lastNode,
              content: lastNode.content + this.currPreStr.slice(0, sliceLength),
            });
          } else {
            this.currRenderQueue.push({
              formatType: 2,
              key: Math.random()
                .toFixed(6)
                .slice(2),
              content: this.currPreStr.slice(0, sliceLength),
            });
          }
          this.currPreStr = this.currPreStr.slice(sliceLength);
          this.dispatchTag = -1;
        }
      }

      this.toolScrollUnder();

      if (this.sseActive || this.currCacheQueue.length > 0) {
        // 再次循环
        this.scheduler();
      } else {
        // 结果了
        const queueLength = this.currRenderQueue.length;
        const lastNode = this.currRenderQueue[queueLength - 1];

        if (lastNode && lastNode?.formatType === 1) {
          this.currRenderQueue.splice(queueLength - 1, 1, {
            ...lastNode,
            content: lastNode.content + this.currPreStr,
          });
        } else {
          this.currRenderQueue.push({
            formatType: 1,
            key: Math.random()
              .toFixed(6)
              .slice(2),
            content: this.currPreStr,
          });
        }

        this.execActive = false;
        this.currPreStr = '';
        this.stackPush();
      }
    },

    // sse完成push
    stackPush() {
      this.sseOpen = false;
      this.historyList.push({
        contentList: this.currRenderQueue,
        roleType: 2,
        isStop: this.stopImmediately,
      });
      this.stopImmediately = false;
      this.currPreStr = '';
      this.currCacheQueue = [];
      this.currRenderQueue = [];
      if (this.needSupervisor) {
        // 插入督学卡片
        this.needSupervisor = false;
        const randomKey = Math.random()
          .toFixed(10)
          .slice(2);
        this.historyList.push({
          messageType: 'supervision_card',
          activeKey: randomKey,
          spervisorStatus: '',
        });
        this.lastSupervisor = randomKey;
      }
      this.toolTableColor();
    },

    // 督学跳转
    onSupervisorJump(item) {
      const { activeKey, spervisorStatus } = item;
      if (activeKey !== this.lastSupervisor || spervisorStatus === 'completed') {
        return;
      }

      if (this.$root.$data.isApp) {
        this.$sendToApp('closePage');
        this.$sendToApp('checkTodayTasks', '');
      } else {
        this.taskModal = true;
      }
    },

    // 换一批快捷提问
    onSwapHello() {
      this.currentWecomeList = this.toolRandomWeCome(this.allWecomeList);
    },

    // input处理相关 -- start
    onTouchstart() {
      console.log('touchstart---------------------------------------');
      if (this.inputRender > 0) {
        this.noScroll = false;
      }
    },

    onTouchstartStop() {
      console.log('onTouchstartStop---------------------------------------');
    },

    onBulr() {
      this.inputRender = -1;
      setTimeout(() => {
        this.noScroll = true;
      }, 10);
    },

    onClick() {
      console.log('click---------------------------------------');
      this.inputRender = -1;
      this.noScroll = true;
      setTimeout(() => {
        window.scrollTo(0, 999999999);
        setTimeout(() => {
          this.inputRender = 9999;
        }, 100);
      }, 300);
    },

    scrollChange(e) {
      if (this.scrollIconSize !== window.pageYOffset) {
        this.scrollIconDisplay = true;
      } else {
        this.scrollIconDisplay = false;
      }
      setTimeout(() => {
        if (this.noScroll) {
          return;
        }
        this.noScroll = true;
        document.getElementById('aiassistantinput')?.blur?.();
      }, 10);
    },
    // input处理相关 -- end

    // 去小程序答疑
    async onGoAnswer() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('goWechatProject', {
          userName: 'gh_5fb96ed24012',
          path: `aiAnswer/answerHome/index`,
        });
      } else if (this.$root.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/aiAnswer/answerHome/index`,
        });
      } else {
        const schemeLink = await miniSchemeUrl(
          'wxdb89cfa2bb60f779',
          'aiAnswer/answerHome/index',
          ``,
        );
        window.location.href = schemeLink;
      }
    },

    // 公式方法
    toolResetRichText(richTxt) {
      console.log('richTxt', richTxt, resetRichText1);
      if (!richTxt) {
        return richTxt;
      }
      return resetRichText1(richTxt);
    },

    // 富文本
    toolMdRender(str) {
      return md.render(str);
    },

    // 取三条随机的欢迎语
    toolRandomWeCome(list) {
      const length = list?.length || 0;

      if (!list || length === 0) {
        return [];
      }
      if (length < 3) {
        return list;
      }

      const newList = [];
      const lsIdx = Math.min(Math.floor(Math.random() * length), length - 1);
      newList.push(list[lsIdx % length]);
      newList.push(list[(lsIdx + 1) % length]);
      newList.push(list[(lsIdx + 2) % length]);
      return newList;
    },

    // 处理欢迎语的时间段
    toolGetTimeRange(timePoint, data) {
      reqTypeList('AI_COMPANION_TIME_HELLO').then(res => {
        let range1 = []; // 上午
        let range2 = []; // 下午
        let range3 = []; // 晚上

        res.data.forEach(item => {
          const { code, value } = item;
          if (code === 'MORNING') {
            range1 = value.split('-');
          } else if (code === 'AFTERNOON') {
            range2 = value.split('-');
          } else if (code === 'EVENING') {
            range3 = value.split('-');
          }
        });

        const timeSeconds = this.toolTimeToSeconds(timePoint);

        // 处理跨天的时间段（结束时间小于开始时间）
        if (
          timeSeconds >= this.toolTimeToSeconds(range1[0]) &&
          timeSeconds <= this.toolTimeToSeconds(range1[1])
        ) {
          this.wecomeTitleObj = {
            wecomeTitle: data.guideTitleMorning,
            wecomeText: data.guideContentMorning,
          };
        } else if (
          timeSeconds >= this.toolTimeToSeconds(range2[0]) &&
          timeSeconds <= this.toolTimeToSeconds(range2[1])
        ) {
          this.wecomeTitleObj = {
            wecomeTitle: data.guideTitleAfternoon,
            wecomeText: data.guideContentAfternoon,
          };
        } else if (this.toolTimeToSeconds(range3[0]) > this.toolTimeToSeconds(range3[1])) {
          // 跨天时间段处理
          if (
            timeSeconds >= this.toolTimeToSeconds(range3[0]) ||
            timeSeconds <= this.toolTimeToSeconds(range3[1])
          ) {
            this.wecomeTitleObj = {
              wecomeTitle: data.guideTitleEvening,
              wecomeText: data.guideContentEvening,
            };
          }
        } else {
          // 非跨天时间段处理
          if (
            timeSeconds >= this.toolTimeToSeconds(range3[0]) &&
            timeSeconds <= this.toolTimeToSeconds(range3[1])
          ) {
            this.wecomeTitleObj = {
              wecomeTitle: data.guideTitleEvening,
              wecomeText: data.guideContentEvening,
            };
          }
        }
      });
    },
    toolTimeToSeconds(timeStr) {
      const [hours, minutes, seconds] = timeStr.split(':').map(Number);
      return hours * 3600 + minutes * 60 + seconds;
    },

    // 滚动工具函数
    toolScrollUnder() {
      this.$nextTick(() => {
        window.scroll(0, 99999999999999);
        setTimeout(() => {
          window.scroll(0, 99999999999999);
          this.scrollIconSize = window.pageYOffset;
          this.scrollIconDisplay = false;
        }, 50);
      });
    },

    toolTableColor() {
      setTimeout(() => {
        if (this.botInfo.tableHeaderColor) {
          try {
            [...document.getElementsByTagName('thead')].forEach(item => {
              item.style.background = `linear-gradient(0deg,${this.botInfo.tableHeaderColor})`;
            });
          } catch (error) {
            console.log('toolTableColor error', error);
          }
        }
      }, 100);
    },

    // 日期格式
    toolRawTime(msgTime, currTime = this.currentTime) {
      if (!msgTime) {
        return '';
      }

      const minutesDiff = moment(currTime).diff(moment(msgTime), 'minutes'); // 分钟差

      const minutesZuo = moment()
        .subtract(1, 'day')
        .format('YYYY-MM-DD'); // 昨天

      const isOneDay = msgTime.slice(0, 10) === currTime.slice(0, 10); // 是否同一天

      const isOneYear = msgTime.slice(0, 4) === currTime.slice(0, 4); // 是否同一年

      // const diff = moment(currTime).format('x') - moment(msgTime).format('x');
      // const time = moment.duration(diff);
      // const days = time.days(); // 天数差
      // console.log('天数差', days);

      if (!isOneYear) {
        return moment(msgTime).format('YYYY年MM月DD日 HH:mm');
      }

      if (minutesZuo === msgTime.slice(0, 10)) {
        return `昨天 ${msgTime.slice(11, -3)}`;
      }

      if (!isOneDay) {
        return moment(msgTime).format('MM月DD日 HH:mm');
      }
      if (minutesDiff > 60) {
        return msgTime.slice(11, -3);
      }
      return '';
    },
  },
  computed: {},
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollChange);
  },
};
</script>

<style lang="scss" scoped>
.task_modal {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  z-index: 13;
  background: rgba(0, 0, 0, 0.7);

  .task_bok {
    position: absolute;
    height: 707px;
    width: 634px;
    top: 346px;
    left: 58px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/task_go_app.png')
      no-repeat;
    background-size: cover;

    .task_btn {
      width: 418px;
      height: 80px;
      background: #ff7f41;
      border-radius: 40px;
      margin: 569px auto 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 25px;
      color: #ffffff;
      line-height: 80px;
      text-align: center;
    }
  }
}
.guide_page {
  position: fixed;
  z-index: 11;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background: #ffffff;
  overflow: hidden;

  .guide_gif {
    position: relative;
    z-index: 1;
    display: block;
    height: 435px;
    width: 435px;
    margin: 268px auto 0;
  }

  .guide_text1 {
    position: relative;
    z-index: 1;
    height: 51px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 36px;
    color: #ff7f41;
    line-height: 51px;
    text-align: center;
    margin-top: 29px;
  }

  .guide_text2 {
    position: relative;
    z-index: 1;
    height: 130px;
    width: 504px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 29px;
    color: #333333;
    line-height: 43px;
    margin: 18px auto 0;
  }

  .guide_bkg {
    display: block;
    z-index: 0;
    position: absolute;
    height: 841px;
    width: 100%;
    left: 0;
    bottom: 0;
  }

  .guide_btn {
    position: absolute;
    width: 362px;
    height: 82px;
    background: #ff7f41;
    border-radius: 41px;
    bottom: 134px;
    left: 194px;

    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 29px;
    color: #ffffff;
    line-height: 82px;

    text-align: center;
  }
}

.ai_box {
  padding-top: 100px;
  position: relative;
  min-height: 100vh;
  background: #f7f8fc;
  font-family: PingFangSC, PingFang SC;

  .list_box {
    width: 750px;
    padding: 36px 36px 300px;

    .history_succ {
      height: 36px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 22px;
      color: #999999;
      line-height: 36px;
      width: 100%;
      text-align: center;
      margin-bottom: 18px;
    }

    .msg_item_box {
      margin-bottom: 51px;
      overflow: hidden;

      .msg_time {
        // height: 31px;
        width: 100%;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 22px;
        color: #999999;
        line-height: 31px;
        text-align: center;
        margin-bottom: 50px;
        display: flex;
        justify-content: center;
        div {
          padding: 4px 14px 5px;
          background: #ffffff;
          border-radius: 7px;
        }
      }

      .user_msg_box {
        float: right;
        background: #ff7f41;
        border-radius: 29px 5px 29px 29px;
        font-weight: 400;
        font-size: 29px;
        color: #ffffff;
        line-height: 51px;
        padding: 22px 29px;
        word-break: break-all;
      }

      .ai_msg_box {
        float: left;
        .ai_title {
          display: flex;
          align-items: center;
          gap: 14px;
          margin-bottom: 14px;

          .ai_title_img {
            display: block;
            height: 76px;
            width: 76px;
          }

          .ai_title_text {
            height: 36px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 25px;
            color: #666666;
            line-height: 36px;
          }
        }

        .ai_msg_list {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 29px;
          color: #333333;
          line-height: 51px;
          padding: 22px 29px;
          background: #ffffff;
          border-radius: 5px 29px 29px 29px;
          max-width: 678px;
          display: flex;
          flex-wrap: wrap;

          .ai_msg_item {
            display: inline-block;

            .ai_msg_markdown {
              display: flex;
              flex-wrap: wrap;
              height: 100%;
              align-items: center;
            }
            .ai_msg_katex {
              display: flex;
              flex-wrap: wrap;
              height: 100%;
              align-items: center;
            }
          }

          .stop_tip {
            width: 620px;
            // height: 2rpx;
            border-top: 2px solid #efefef;
            // height: 36rpx;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 25px;
            color: #999999;
            line-height: 36px;
            margin-top: 19px;
            padding-top: 19px;
          }

          .ai_loading {
            height: 51px;
            width: 51px;
          }
        }
      }
    }

    .msg_item_box:last-child {
      margin-bottom: 30px;
    }

    .msg_ai_tip {
      height: 36px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 22px;
      color: #999999;
      line-height: 36px;
      text-align: center;
    }

    .wecome_box {
      width: 678px;
      // margin-bottom: 51px;

      .wecome_icon_box {
        height: 303px;
        width: 678px;
        background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/aiCompanion/wecome_icon.png')
          no-repeat;
        background-size: cover !important;
        overflow: hidden;

        .wecome_title_hello {
          height: 40px;
          font-weight: 600;
          font-size: 29px;
          color: #ff5a12;
          line-height: 40px;
          margin-top: 62px;
          margin-left: 199px;
        }
        .wecome_title_text {
          width: 457px;
          font-weight: 400;
          font-size: 25px;
          color: #333333;
          line-height: 36px;
          margin-top: 7px;
          margin-left: 199px;
        }
      }

      .wecome_list {
        margin-top: -72px;
        background: #ffffff;
        border-radius: 18px;
        padding: 36px 29px 29px;
        .wecome_list_title {
          height: 36px;

          display: flex;
          align-items: center;
          .wecome_list_tip {
            height: 36px;
            font-weight: 400;
            font-size: 25px;
            color: #999999;
            line-height: 36px;
          }

          .refresh_icon {
            height: 29px;
            width: 29px;
            margin-left: auto;
          }

          .refresh_tip {
            height: 36px;
            font-weight: 400;
            font-size: 25px;
            color: #ff7f41;
            line-height: 36px;
            margin-left: 7px;
          }
        }

        .wecome_quick_list {
          display: flex;
          flex-direction: column;
          margin-top: 22px;
          gap: 14px;

          .wecome_quick_item {
            display: flex;
            width: 620px;
            background: #f7f8fc;
            border-radius: 11px;
            padding: 18px 29px;
            justify-content: space-between;
            align-items: center;

            .wecome_quick_text {
              width: 496px;
              font-weight: 400;
              font-size: 29px;
              color: #333333;
              line-height: 40px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }

            .wecome_quick_icon {
              height: 36px;
              width: 36px;
            }
          }
        }
      }
    }

    .supervisor_box {
      position: relative;
      width: 678px;
      height: 127px;
      background: linear-gradient(180deg, #ffffff 0%, #eef5ff 100%);
      border-radius: 18px;
      border: 2px solid #ffffff;

      .supervisor_icon {
        float: left;
        display: block;
        height: 72px;
        width: 72px;
        margin-top: 27px;
        margin-left: 29px;
      }

      .supervisor_text1 {
        float: left;
        width: 370px;
        height: 40px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 29px;
        color: #333333;
        line-height: 40px;
        margin-top: 25px;
        margin-left: 22px;
      }

      .supervisor_text2 {
        float: left;
        height: 31px;
        width: 348px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 22px;
        color: #999999;
        line-height: 31px;
        margin-top: 7px;
        margin-left: 22px;
      }

      .supervisor_btn {
        position: absolute;
        width: 134px;
        height: 51px;
        border-radius: 25px;
        font-weight: 500;
        font-size: 25px;
        line-height: 51px;
        text-align: center;

        top: 38px;
        right: 29px;

        color: #ffffff;
        background: #d7daea;
      }

      .supervisor_btn_actvie {
        color: #ffffff;
        background: #ff7f41;
      }
    }
  }

  .scroll_icon {
    position: fixed;
    height: 72px;
    width: 72px;
    left: 339px;
    bottom: -72px;
    transition: bottom 0.3s ease-in-out;
  }

  .scroll_icon_show {
    bottom: 283px;
  }

  .bottom_box {
    position: fixed;
    z-index: 10;
    width: 750px;
    height: 264px;
    left: 0;
    bottom: 0;
    background: #f7f8fc;

    padding: 29px 36px 0;

    .jump_btn_box {
      display: flex;
      height: 65px;
      overflow-x: auto;
      gap: 18px;

      .jump_btn_item {
        width: 181px;
        height: 65px;
        background: #ffffff;
        border-radius: 14px;
        border: 2px solid #e8eaef;
        display: flex;
        gap: 11px;
        align-items: center;
        justify-content: center;

        .jump_btn_icon {
          display: block;
          height: 33px;
          width: 33px;
        }

        .jump_btn_text {
          font-weight: 400;
          font-size: 25px;
          color: #333333;
          line-height: 36px;
        }
      }
    }

    .input_box {
      margin-top: 29px;
      height: 79px;

      .input_area {
        float: left;
        height: 79px;
        width: 591px;
        background: #ffffff;
        border-radius: 40px;
        overflow: hidden;
        border: 2px solid #e8eaef;
      }

      .input_btn {
        float: left;
        height: 79px;
        width: 79px;
        margin-left: 7px;

        img {
          display: block;
          height: 100%;
          width: 100%;
        }
      }
    }
  }

  .bottom_absolate {
    position: absolute;
  }
}

.ai_box_top {
  padding-top: 0;
}

::v-deep strong {
  font-weight: bolder !important;
}

::v-deep table {
  border-radius: 18px;
  display: inline-block;
  overflow: hidden;
  border: 1px solid #efefef;
}

::v-deep thead {
  width: 620px;
  height: 91px;
  background: linear-gradient(270deg, #ff4605 0%, #ff7f41 100%);
  border-radius: 18px 18px 0px 0px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 22px;
  color: #ffffff;
  line-height: 31px;
  th {
    min-width: 100px;
    padding: 31px 18px 29px;
    border-right: 1px solid #ffffff;
  }

  tr :last-child {
    border-right: none;
  }
}

::v-deep tbody {
  td {
    border: 1px solid #efefef;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 22px;
    color: #333333;
    line-height: 31px;
    padding: 29px 18px 31px;
  }
}

::v-deep input {
  margin-top: -4px;
}

p {
  display: inline-block !important;
}

::v-deep p {
  display: inline-block !important;
}
</style>